// extracted by mini-css-extract-plugin
export default {"starIconActive":"components_starIconActive__Q0ynP","starIconInactive":"components_starIconInactive__fg5Sq"};